import useWindowWidth from "./useWindowWidth"

const useIsDesktopWidth = () => {
  const windowWidth = useWindowWidth()

  return windowWidth >= 840
}

export default useIsDesktopWidth
